/**
 * Normalize a sponsor website URL for use as an href.
 * - Blocks dangerous URI schemes (javascript:, data:, vbscript:) → returns null.
 * - Passes through http(s) URLs unchanged.
 * - Prepends https:// to protocol-less values (e.g. "acme.com").
 * @param {string|null|undefined} url
 * @returns {string|null} a safe href, or null when absent/blocked
 */
export const normalizeUrl = url => {
  if (!url) return null;
  // Browsers ignore embedded whitespace (spaces, tabs, newlines) when resolving
  // a scheme, so strip it before testing so e.g. "java\tscript:" can't slip through.
  const scheme = String(url)
    .replace(/\s+/g, '')
    .toLowerCase();
  if (/^(javascript|data|vbscript):/.test(scheme)) return null;
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
};
